module.exports = __webpack_public_path__ + "img/login-lacomunachilibulo.591a5bb4.svg";